var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "upload-video",
        width: "420",
        adaptive: "",
        height: "auto",
        "pivot-y": _vm.$isMobile ? 1 : 0.5
      },
      on: { "before-open": _vm.handleBeforeOpen }
    },
    [
      _c("UploadVideoComponent", {
        attrs: {
          "upload-version": _vm.uploadVersion,
          "can-collect-title": !_vm.uploadVersion
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }